import React from "react";
import { useDropzone } from "react-dropzone";
import UploadIcon from "../../assets/Icons/upload.svg";
import { referencesFormats } from "../../constants/commonConstants";
import { ClipLoader } from "react-spinners";

const DragUpload = ({ onFileUpload, dragText, uploadText, uploadFiles = [], isLoading = false }) => {
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    //accept: '*/*',  // Accepts all file types
    accept: referencesFormats,
    onDrop: (acceptedFiles) => {
      onFileUpload(acceptedFiles);
    },
  });

  return (
    <div
      {...getRootProps()}
      className="font-inter px-4 py-2 border border-dashed rounded-[5px] border-blue-shades font-Inter h-[220px] sm:h-[204px] w-full flex flex-col items-center justify-center cursor-pointer hover:bg-gray-100 transition"
    >
      <input {...getInputProps()} />

      {
        isLoading ? (
          <>
            <ClipLoader
              loading={isLoading}
              speedMultiplier={1}
              size={22}
              color="#60a5fa"
            />
          </>
        ) : (
          <>
            <div className="mb-[26.5px] relative">
              <img src={UploadIcon} className="w-[51px] h-[43px] " alt="Img" />
              <span className=" w-[22px] h-[22px] rounded-full bg-blue-400 text-[14px] font-inter text-white flex items-center justify-center absolute -top-1 -right-1">
                {uploadFiles.length || 0}
              </span>
            </div>
          </>
        )
      }

      <p className="text-secondary text-center text-level-4 mb-[8px] leading-5">
        <span className="text-secondary font-normal">{dragText}</span>{" "}
        <span className="text-primary font-semibold">{uploadText}</span> - Maximum size of a file is 20MB
      </p>
      <p className="text-gray text-level-5  mb-[8px]">OR</p>
      <p className="border-[1px] border-blue-shades rounded-[8px] py-[6px] px-3 text-level-5 text-blue-shades font-semibold leading-[18px] ">
        Browse files
      </p>
    </div>
  );
};

export default DragUpload;
